import { useAuth } from "../../providers/authprovider";
import React, { useEffect, useState } from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import useAlert from "../../components/CustomAlert";
import AddNoteForm from "./EventNoteForm";
import ImageModal from "./ImageModal";

function getEventHeader({ type, date }) {
  switch (type) {
    case "MALFUNCTION":
      return `${date.split("T")[0]} : Zgłoszenie/Awaria `;
    case "TRAINING":
      return `${date.split("T")[0]} : Szkolenie`;
    default:
      return null;
  }
}

export default function Notes(props) {
  const { event } = props;
  const { showAlert, hideAlert, alert } = useAlert();
  const { calendar } = useAuth();
  const [notes, setNotes] = useState(undefined);
  const [editNote, setEditNote] = useState(undefined);
  const handleClose = props.onHide;
  const [showImageModal, setShowImageModal] = useState(false);
  const [modalImageIds, setModalImageIds] = useState([]);
  const [modalImageIndex, setModalImageIndex] = useState(0);

  useEffect(() => {
    calendar.getEventNotes(event.id, ({ success, status, content }) => {
      if (!success) {
        setNotes([]);
        return showAlert(status);
      }

      setNotes(content);
    });
  }, []);

  const handleNoteSaved = (note) => {
    const existingIndex = notes.findIndex((c) => c.id === note.id);
    if (existingIndex > -1) notes.splice(existingIndex, 1, note);
    else notes.unshift(note);

    setEditNote(undefined);
    setNotes([...notes]);
  };

  const handleDeleteNote = (event, noteId) => {
    event.stopPropagation();

    if (
      !window.confirm(
        "Potwierdź usunięcie notatki z historii. Usunięcie jest trwałe i nie może zostać cofnięte."
      )
    )
      return;

    hideAlert();

    calendar.removeEventNote(noteId, ({ success, error }) => {
      if (!success) return showAlert(error);

      const existingIndex = notes.findIndex((c) => c.id === noteId);
      if (existingIndex < 0) return;

      notes.splice(existingIndex, 1);
      setEditNote(undefined);
      setNotes([...notes]);
    });
  };

  const handleImageClick = (images, index) => {
    setModalImageIds(images);
    setModalImageIndex(index);
    setShowImageModal(true);
  };

  return (
    <>
      <Modal size={"xl"} {...props} show={true} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{getEventHeader(event)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {alert()}
          <AddNoteForm
            eventId={event.id}
            note={editNote}
            onSave={handleNoteSaved}
          />
          {notes != undefined ? (
            <Table hover size="sm" className="w-100" responsive>
              <thead>
                <tr>
                  <th>Notatka</th>
                  <th>Obrazy</th>
                  <th>Data i godzina</th>
                  <th>Użytkownik</th>
                  <th>Kasuj</th>
                </tr>
              </thead>
              <tbody>
                {notes &&
                  notes.map((note) => {
                    const date = note.created_at.slice(0, 10);
                    const time = note.created_at.slice(11, 19);

                    return (
                      <tr
                        className={"cursor-pointer"}
                        key={note.id}
                        onClick={() => setEditNote(note)}
                      >
                        <td>
                          <div style={{ whiteSpace: "pre-wrap" }}>
                            {note.value}
                          </div>
                        </td>
                        <td style={{ width: "40%" }}>
                          <div
                            style={{
                              display: "flex",
                              gap: "8px",
                              overflowX: "auto",
                            }}
                          >
                            {note.images &&
                              note.images.length > 0 &&
                              note.images.map((fileId, index) => (
                                <AuthorizedImage
                                  key={fileId}
                                  eventId={event.id}
                                  noteId={fileId}
                                  style={{
                                    maxWidth: "25%",
                                    height: "auto",
                                    objectFit: "contain",
                                  }}
                                  className="rounded"
                                  onClick={() =>
                                    handleImageClick(note.images, index)
                                  }
                                />
                              ))}
                          </div>
                        </td>
                        <td>
                          {time} {date}
                        </td>
                        <td>{note.name}</td>
                        <th>
                          <Button
                            className={"btn-close"}
                            onClick={(e) => handleDeleteNote(e, note.id)}
                          />{" "}
                        </th>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>
          ) : (
            <div>
              <FontAwesomeIcon icon={faSpinner} spin={true} />
              Pobieranie danych...
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Zamknij
          </Button>
        </Modal.Footer>
      </Modal>
      <ImageModal
        show={showImageModal}
        onHide={() => setShowImageModal(false)}
        eventId={event.id}
        imageIds={modalImageIds}
        currentIndex={modalImageIndex}
      />
    </>
  );
}

function AuthorizedImage({
  eventId,
  noteId,
  style = {},
  className = "",
  onClick,
}) {
  const {
    calendar: { downloadNoteImage },
  } = useAuth();
  const [imageSrc, setImageSrc] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    downloadNoteImage(eventId, noteId, (response) => {
      if (response.success) {
        // setImageSrc(response.content);
        const reader = new FileReader();
        reader.onloadend = function () {
          setImageSrc(reader.result);
        };
        reader.onerror = function () {
          setError(true);
        };
        reader.readAsDataURL(response.content);
      } else {
        setError(true);
      }
    });
  }, [eventId, noteId]);

  if (error) {
    return (
      <div
        style={{ width: "80px", height: "80px", backgroundColor: "#f0f0f0" }}
      >
        Error loading image
      </div>
    );
  }

  if (!imageSrc) {
    return (
      <div
        style={{ width: "80px", height: "80px", backgroundColor: "#f0f0f0" }}
      >
        Loading...
      </div>
    );
  }

  return (
    <img src={imageSrc} style={style} className={className} onClick={onClick} />
  );
}
